import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '@/app/store/index.ts'
import Work from '@/app/modules/work/Work.vue'
import Login from '@/app/modules/login/Login.vue'


Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Work',
		component: Work,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		redirect: "/"
	},
	/* 	{
			path: '/404',
			name: 'NotFound',
			component: Login
		}, */
	{
		path: '*',
		redirect: "/login"
	}
]

const router = new VueRouter({
	routes
})

//Check user auth
/* router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/login');
	} else {
		next();
	}
}) */

export default router
